import { Component, OnInit, inject, model } from '@angular/core';
import { NgIf, JsonPipe } from '@angular/common';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { BookService } from 'src/app/services/book.service';
import { IBookSortFilterSet, ISeriesNames, BookSortFilterSet } from '../../_models'
import { AuthService } from 'src/app/services/auth.service';
import { LogService } from 'src/app/services';


@Component({
  selector: 'kbm-filter-sort',
  templateUrl: './filter-sort.component.html',
  styleUrls: ['./filter-sort.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    // JsonPipe
  ]
})
export class FilterSortComponent implements OnInit {

  bookService = inject(BookService);
  authService = inject(AuthService);
  logService = inject(LogService);

  filterSet = model.required<IBookSortFilterSet>();

  currentOrder = 'title';

  typeOptions = [
    'Both',
    'Kindle eBook',
    'Audible Book'
  ]

  seriesOptions!: ISeriesNames[];
  authorOptions!: { author: string }[];
  narratorOptions!: { narrator: string }[];

  me = this.authService.user()?.username || '';

  constructor() { }

  
  ngOnInit(): void {

    // Populate Pick Lists
    this.getAuthorList();
    this.getNarratorList();
    this.getSeriesList();
  }

  onSelectChange(event: any, fieldName: string) {
    this.filterSet.update((filterSet) => ({
      ...filterSet,
      [fieldName]: event?.value
    }))
  }

  onSortSelectChange(event: any) {
    this.filterSet.update((filterSet) => ({
      ...filterSet,
      sortBy: event?.value,
      sortDirection: 'asc'
    }))
  }
  onTextFieldChange(event: any, fieldName: string) {
    this.filterSet.update((filterSet) => ({
      ...filterSet,
      [fieldName]: event?.target?.value
    }))
  }

  onCheckBoxChange(event: any, fieldName: string) {
    this.filterSet.update((curValue) => ({
      ...curValue,
      [fieldName]: event?.checked
    }))
  }

  isLoggedIn(): boolean {
    return (this.authService.isLoggedIn())
  }

  clearFilters() {
    const isOpen = this.filterSet().sortFilterIsOpen;

    this.filterSet.set(new BookSortFilterSet(
      {
        startsWithFlag: false,
        // We could probably assume that this is true
        // but it is better to be explicit
        sortFilterIsOpen: isOpen,
      }
    ));
  }

  async getSeriesList() {
    try {
      this.seriesOptions = await this.bookService.getSeries();
      this.seriesOptions.unshift({ seriesName: '-- Select a Series --', sortName: '--' })
    }
    catch (err) {
      this.logService.error(JSON.stringify(err));
      console.log(err);
    }
  }
  async getAuthorList() {
    try {
      this.authorOptions = await this.bookService.getAuthorList();
      this.authorOptions.unshift({ author: '-- Select an Author --' });
    }
    catch (err) {
      this.logService.error(JSON.stringify(err));
      console.log(err);
    }
  }
  async getNarratorList() {
    try {
      this.narratorOptions = await this.bookService.getNarratorList();
      this.narratorOptions.unshift({ narrator: '-- Select a Narrator --' });
    }
    catch (err) {
      this.logService.error(JSON.stringify(err));
      console.log(err);
    }
  }

  getDiagnostic() {
    return this.filterSet();
  }
}
